export default {
    typeDictOptions: [
        {
            value: "1",
            name: "智算",
        },
        {
            value: "2",
            name: "超算",
        },
        {
            value: "3",
            name: "通算",
        },
        {
            value: "4",
            name: "量算",
        },
    ],
    regionDictOptions: [
        {
            value: "shanghai",
            name: "上海",
        },
        {
            value: "jiangsu",
            name: "江苏",
        },
        {
            value: "zhejiang",
            name: "浙江",
        },
        {
            value: "anhui",
            name: "安徽",
        },
    ],

    // 产品分类
    goodsCategoryOptions: [
        { label: "智算", value: 1 },
        { label: "超算", value: 2 },
        { label: "通算", value: 3 },
        { label: "量算", value: 4 },
    ],
    // 库存状态
    inventoryStatusOptions: [
        { label: "充足", value: 1 },
        { label: "紧张", value: 2 },
    ],
    // 地区
    regionOptions: [
        { label: "上海", value: 1 },
        { label: "江苏", value: 2 },
        { label: "浙江", value: 3 },
        { label: "安徽", value: 4 },
    ],
};